import { ReactNode } from 'react'

import cn from 'clsx'
import { useNavigate } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from '@App/hooks'
import { accountDepositAsync, asyncLogout } from '@App/redux/slices/user/UserSlice'
import { ArrowRight } from '@App/static/icons/AccountOrdersPageIcons'
import {
  AccountsIcon,
  DepositIcon,
  LogoutArrowIcon,
  OptionsIcon,
  RefreshCircleIcon,
  RequestIcon,
} from '@App/static/icons/HeaderIcon'

import { MODAL_TYPES } from '@Redux/slices/modals/enums'
import { setModal } from '@Redux/slices/modals/ModalSlice'
import { currentWallet } from '@Redux/slices/user/selectors'

import { ROUTE_NAMES } from '@UI/crypto_exchange/desktop/routes/routeNames'

import s from './AccountOptions.module.scss'

type Option = {
  name: string
  action?: () => void
  icon?: ReactNode
}

export const AccountOptions = () => {
  const dispatch = useAppDispatch()
  const wallet = useAppSelector(currentWallet)
  const handleLogout = () => {
    dispatch(asyncLogout())
  }
  const handleTraidingOptions = () => {
    dispatch(
      setModal({
        modalType: MODAL_TYPES.TRAIDING_OPTIONS_MODAL,
        data: {
          wallet: wallet
        }
      }),
    )
  }

  const addMoneyToAccount = () => {
    !!wallet && dispatch(accountDepositAsync({ account_id: Number(wallet.id), amount: 10000 }))
  }


  const options: Option[] = [
    { name: 'Top up €10,000', icon: <DepositIcon className={cn(s.icon, s.deposit)} />, action: addMoneyToAccount },
    {
      name: 'Trading options',
      icon: <OptionsIcon className={cn(s.icon, s.settings)} />,
      action: handleTraidingOptions,
    },

    { name: 'My requests', icon: <RequestIcon className={s.icon} /> },
    { name: 'Switch to Live', icon: <RefreshCircleIcon className={cn(s.icon, s.switch)} /> },
    { name: 'Logout', icon: <LogoutArrowIcon className={s.icon} />, action: handleLogout },
  ]
  return (
    <div className={s.container}>
      {options.map((op) => (
        <div key={op.name} className={s.option} onClick={op.action}>
          <span className={s.left}>
            {op.icon}
            {op.name}
          </span>
          <span className={s.right}>
            <ArrowRight className={s.arrowIcon} />
          </span>
        </div>
      ))}
    </div>
  )
}
